var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08666 24.528L12.1625 18.3731L14.4843 21.3346L10.0091 27.0256C8.29518 29.2034 5.12372 26.9084 7.08666 24.528ZM13.0145 10.5115C13.4979 8.93435 13.2758 7.58666 11.4593 5.58466L7.02074 0.245176C6.39084 -0.494588 4.90643 0.591864 5.52656 1.48788L9.07645 5.86055C9.74786 6.676 8.50027 7.75512 7.80689 6.91526L4.13492 2.39367C3.45131 1.60996 2.0377 2.64514 2.75305 3.54115C3.78824 4.7863 5.38984 6.82004 6.42502 8.06519C7.14281 8.79519 6.05148 9.87676 5.34345 8.96609L1.69834 4.47379C1.16366 3.89273 0.289615 4.25406 0.0576753 4.93279C-0.191354 5.65791 0.421454 6.1877 0.838945 6.72483L4.90643 11.9789C6.16867 13.4413 7.57983 14.308 9.2205 13.8173C9.47197 13.7416 9.7796 13.5878 10.1092 13.3851L21.0372 27.4919C21.6256 28.2512 22.7609 28.3318 23.4982 27.719L23.6667 27.5798C24.4968 26.8889 24.631 25.6267 23.9206 24.8112L12.348 11.515C12.6849 11.139 12.9315 10.7825 13.0145 10.5115ZM16.1079 13.5878L17.9072 11.4051C15.5927 5.66767 24.1696 -1.979 28.3274 1.53671C33.3788 5.81172 25.8713 16.1147 20.5953 13.5683L18.4639 16.2758L16.1079 13.5878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashMenu);
export default __webpack_public_path__ + "static/media/dash-menu.038f36d3ce07c2f1d837b7e72fd4d62f.svg";
export { ForwardRef as ReactComponent };